import React from "react";
import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";

const BLOBS = [
  {
    startX: 120,
    endX: 200,
    startY: 200,
    endY: 350,
    size: 460,
    color: "rgba(255, 183, 213, 0.45)", // Soft Pastel Pink
    phase: 0,
  },
  {
    startX: 800,
    endX: 680,
    startY: 250,
    endY: 450,
    size: 500,
    color: "rgba(200, 164, 255, 0.35)", // Soft Pastel Purple
    phase: 60,
  },
  {
    startX: 220,
    endX: 380,
    startY: 1300,
    endY: 1100,
    size: 480,
    color: "rgba(160, 231, 255, 0.35)", // Baby Blue
    phase: 120,
  },
  {
    startX: 780,
    endX: 880,
    startY: 1200,
    endY: 1000,
    size: 420,
    color: "rgba(255, 228, 160, 0.4)", // Cream Yellow
    phase: 180,
  },
];

const SPARKLES = [
  { top: "8%", left: "12%", delay: 0 },
  { top: "12%", left: "82%", delay: 20 },
  { top: "25%", left: "90%", delay: 40 },
  { top: "42%", left: "6%", delay: 15 },
  { top: "60%", left: "88%", delay: 50 },
  { top: "72%", left: "10%", delay: 30 },
  { top: "84%", left: "80%", delay: 10 },
];

export const VectorMotionBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width,
        height,
        backgroundColor: "#fff2f8", // Warm bubblegum/pinkish base washi color
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      {/* Morphing Pastel Blobs */}
      {BLOBS.map((blob, i) => {
        const cycleFrame = (frame + blob.phase) % 250;

        const x = interpolate(
          cycleFrame,
          [0, 125, 250],
          [blob.startX, blob.endX, blob.startX],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
        );

        const y = interpolate(
          cycleFrame,
          [0, 125, 250],
          [blob.startY, blob.endY, blob.startY],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
        );

        const opacityPulse = interpolate(
          cycleFrame,
          [0, 62, 125, 187, 250],
          [0.8, 1.1, 0.85, 1.1, 0.8],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
        );

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: x,
              top: y,
              width: blob.size,
              height: blob.size,
              borderRadius: "50%",
              background: blob.color,
              filter: "blur(90px)",
              opacity: opacityPulse,
              transform: "translate(-50%, -50%)",
            }}
          />
        );
      })}

      {/* Floating Sparkle Stars */}
      {SPARKLES.map((sparkle, i) => {
        const cycleFrame = (frame + sparkle.delay) % 120;

        const floatY = interpolate(cycleFrame, [0, 60, 120], [0, -15, 0], {
          extrapolateLeft: "clamp",
          extrapolateRight: "clamp",
        });

        const sparkleOpacity = interpolate(
          cycleFrame,
          [0, 30, 60, 90, 120],
          [0.3, 0.9, 0.4, 0.9, 0.3],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
        );

        const sparkleScale = interpolate(
          cycleFrame,
          [0, 60, 120],
          [0.8, 1.2, 0.8],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
        );

        return (
          <span
            key={i}
            style={{
              position: "absolute",
              top: sparkle.top,
              left: sparkle.left,
              fontSize: "24px",
              color: "#c8a4ff", // Pastel Purple stars
              opacity: sparkleOpacity,
              transform: `translateY(${floatY}px) scale(${sparkleScale})`,
              userSelect: "none",
              pointerEvents: "none",
            }}
          >
            ✦
          </span>
        );
      })}

      {/* Clean border lines */}
      <div
        style={{
          position: "absolute",
          top: "30px",
          bottom: "30px",
          left: "30px",
          right: "30px",
          border: "2px solid rgba(255, 183, 213, 0.3)",
          borderRadius: "16px",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
